import { useSyncExternalStore } from 'react';

// Counts the shared <Modal>s currently open, so barcode listeners can pause while a
// dialog is up:  useBarcodeBuffer(handleScan, { active: scanActive && !useAnyModalOpen() })
let openCount = 0;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

export const registerOpenModal = () => {
  openCount += 1;
  notify();
  let released = false;
  // Returns the matching release; calling it twice is harmless
  return () => {
    if (released) return;
    released = true;
    openCount -= 1;
    notify();
  };
};

export const getOpenModalCount = () => openCount;

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useModalOpenCount = () => useSyncExternalStore(subscribe, getOpenModalCount, getOpenModalCount);

const useAnyModalOpen = () => useModalOpenCount() > 0;

export default useAnyModalOpen;
